import { apiClient } from '../ApiClient';
import { ApiResponse, RequestPayload } from "../ApiClient/types"
import { SsoToken, TenantConfiguration, TenantVerificationResponse, VerifyTenantDomainRequest } from "./types";
import { User } from '../types';
import { AuthenticateResponse } from '../AccountService/types';

class TenantService {
  /*** Returns confirmation of tenant email domain
   * @param payload  = RequestPayload<VerifyTenantDomainRequest> 
   * @example
   * ```ts
   * let request: VerifyTenantDomainRequest = { domain: emailDomain }
   * let payload: RequestPayload<VerifyTenantDomainRequest> = { payload: request };
   * ```
   * @returns Success Message
   */
  async verifyDomain(payload: RequestPayload<VerifyTenantDomainRequest>): Promise<ApiResponse<TenantVerificationResponse>> {
    return apiClient.post<TenantVerificationResponse>(
      `/tenant/verifydomain`,
      payload
    );
  }

    /*** Syncs sso token for  user
   * @param payload  = RequestPayload<SsoToken> 
   * @example
   * ```ts
   * let request: SsoToken = { token: ssoToken }
   * let payload: RequestPayload<SsoToken> = { payload: request };
   * ```
   * @returns Success Message
   */
  async syncSsoToken(payload: RequestPayload<SsoToken>): Promise<ApiResponse<AuthenticateResponse>> {
    return apiClient.post<AuthenticateResponse>(
      `/accounts/sync-sso-token`,
      payload
    );
  }
}

export { TenantService }